import { render, staticRenderFns } from "./AddAttachment.vue?vue&type=template&id=29aa484a"
import script from "./AddAttachment.vue?vue&type=script&lang=js"
export * from "./AddAttachment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports